exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mdl-button[_v-dc34f090]{margin:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-dc34f090&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./~/eslint-loader!./src/admin/pages/Login.vue
// module id = 273
// module chunks = 0